import { FC } from "react";
// Redux
import { useAppSelector } from "hooks/useStore";
import { selectResult } from "store/player/playerSelectors";
import { selectQuiz } from "store/quiz/quizSelectors";
import IQuiz from "models/Quiz";
import IAnswer from "models/Answer";

interface Props {
  questionAnswers: IAnswer[];
  questionResults: any;
  allAnswers: number;
}
 
const AnswerList:FC<Props> = ({ questionAnswers, questionResults, allAnswers }) => {
  const result:any = useAppSelector(selectResult);
  const storeQuiz = useAppSelector(selectQuiz);
  const quiz:IQuiz | null = storeQuiz || result?.quiz || null;

  const topPercent = Math.max(...questionAnswers.map(answer => {
    const value = questionResults?.answers[answer.ref] || 0;
    return Number((value / allAnswers * 100).toFixed(2)) || 0;
  }));

  return (
    <div className="landscape:max-h-[500px] flex flex-col flex-wrap gap-x-6 gap-y-8">
      {questionAnswers.slice(0, 8).map((answer) => {
        const value = questionResults?.answers[answer.ref] || 0;
        const percent = Number((value / allAnswers * 100).toFixed(2)) || 0;

        const isTopPercent = percent === topPercent;

        return (
          <div
            key={answer.ref}
            className="landscape:w-[calc(50%-0.75rem)] shadow-primary-border rounded-md overflow-hidden"
          >
            <div
              className={`
                px-4 py-2
                flex justify-between items-center gap-2
                ${isTopPercent ? 'text-[#242324]' : ''}
              `}
              style={{ background: isTopPercent ? `linear-gradient(to right, ${quiz?.publicLeaderboard.primaryColor}, ${quiz?.publicLeaderboard.secondaryColor})` : 'rgb(229,231,235,0.2)' }}
            >
              <p className="py-2 text-lg sm:text-5xl font-bold text-ellipsis whitespace-nowrap overflow-hidden">{answer.title}</p>
              <p className="text-md sm:text-3xl font-bold">{`${percent}%`}</p>
            </div>
          </div>
        );
      })}
    </div>
  );
}
 
export default AnswerList;
